// YouTube Error 153: document meta referrer in site-header.html + shared embed helpers (utils/video-embeds.js).

import { injectCoverVideoEmbed } from "../utils/video-embeds.js";

const injectVideo = (videoWrap) => {
  const videoType = (videoWrap.getAttribute("data-video-type") || "mp4").toLowerCase();
  const videoSrc = videoWrap.getAttribute("data-video-src") || "";
  const videoId = (videoWrap.getAttribute("data-video-id") || "").trim();

  return injectCoverVideoEmbed(videoWrap, videoType, { src: videoSrc, id: videoId }, "fullwidth-video__video");
};

const fadeToVideo = (posterEl, videoEl) => {
  const gsap = window.gsap;
  if (gsap) {
    gsap.set(videoEl, { opacity: 0 });
    gsap.to(posterEl, {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => posterEl.remove(),
    });
    gsap.to(videoEl, { opacity: 1, duration: 0.6, ease: "power2.out", delay: 0.2 });
  } else {
    posterEl.style.transition = "opacity 0.6s ease";
    videoEl.style.transition = "opacity 0.6s ease";
    videoEl.style.opacity = "0";
    posterEl.style.opacity = "0";
    requestAnimationFrame(() => {
      videoEl.style.opacity = "1";
    });
    posterEl.addEventListener("transitionend", () => posterEl.remove(), { once: true });
  }
};

const initSectionReveal = (section) => {
  const titleEl = section.querySelector(".fullwidth-video__title");
  const eventWrap = section.querySelector(".event-wrap");
  if (!titleEl || !eventWrap) return;

  const gsap = window.gsap;
  if (gsap) {
    gsap.set([titleEl, eventWrap], { opacity: 0 });
  } else {
    titleEl.style.opacity = "0";
    eventWrap.style.opacity = "0";
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (!entry.isIntersecting) return;
      observer.disconnect();
      if (gsap) {
        gsap
          .timeline({ defaults: { ease: "power2.out" } })
          .to(titleEl, { opacity: 1, duration: 0.6 })
          .to(eventWrap, { opacity: 1, duration: 0.6 });
      } else {
        titleEl.style.transition = "opacity 0.6s ease";
        eventWrap.style.transition = "opacity 0.6s ease";
        titleEl.style.opacity = "1";
        setTimeout(() => {
          eventWrap.style.opacity = "1";
        }, 400);
      }
    },
    { threshold: 0.8 }
  );
  observer.observe(section);
};

export const fullcolVideo = () => {
  const sections = document.querySelectorAll(".fullwidth-video");
  if (!sections.length) return;

  const pending = [];

  sections.forEach((section) => {
    const videoWrap = section.querySelector(".fullwidth-video__video-wrap");
    if (!videoWrap) {
      initSectionReveal(section);
      return;
    }

    const posterSrc = videoWrap.getAttribute("data-poster-src");
    const poster = document.createElement("img");
    poster.className = "fullwidth-video__poster";
    poster.src = posterSrc || "";
    poster.alt = "";
    poster.loading = "eager";
    videoWrap.appendChild(poster);

    pending.push({ section, videoWrap, poster });
    initSectionReveal(section);
  });

  const onLoad = () => {
    window.removeEventListener("load", onLoad);
    pending.forEach(({ videoWrap, poster }) => {
      Promise.resolve(injectVideo(videoWrap)).then((videoEl) => {
        if (videoEl) fadeToVideo(poster, videoEl);
      });
    });
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
};
